import { useEffect, useState } from 'react';
import { flashcardService } from '../../queries';
import { useUserStore } from '../../../Auth/stores/authStore';

const useFlashcardDiscipline = () => {
  const { user } = useUserStore();
  const memoryUserUuid = user?.memoryUserUuid;

  const [isLoading, setIsLoading] = useState(false);
  const [flashcards, setFlashcards] = useState<IGroupedByDisciplineResponse[]>([]);

  const fetchFlashcards = async () => {
    if (!memoryUserUuid) return;

    setIsLoading(true);
    try {
      const response = await flashcardService.groupByDiscipline(memoryUserUuid);
      setFlashcards(response);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFlashcards();
  }, [memoryUserUuid]);

  return { isLoading, flashcards };
};

export default useFlashcardDiscipline;
